// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-selector {
  height: 100%;
  width: 100%;
  background-color: rgb(242, 242, 242);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.contacts-selector-controls {
  padding: 8px;
  width: calc(100% - 16px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.contacts-selector-search-container {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.contacts-selector-invite-button {
  color: rgb(222, 72, 88);
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
}

.contacts-selector-invite-button .material-icons {
  font-size: 18px;
  margin-right: 6px;
}

.contacts-selector-invite-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.contacts-selector-instructions {
  margin: 8px 0;
  font-size: 12px;
  line-height: 18px;
  color: rgb(153, 153, 153);
  font-family: Roboto, Arial, sans-serif;
  width: 100%;
}

.contacts-selector-permissions-line {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: rgb(102, 102, 102);
  width: 100%;
  margin: 8px 0 16px;
}

.contacts-selector-permissions-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.contacts-selector-permissions-icon-wrapper ion-icon {
  font-size: 24px;
  color: rgb(71, 71, 71);
  cursor: pointer;
}

.contacts-selector-permissions-icon-wrapper ion-icon:hover {
  color: rgb(51, 51, 51);
}

.contacts-selector-permissions-popup {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 280px;
  max-width: 360px;
  z-index: 2500;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease-in-out, visibility 0.15s ease-in-out;
}

.contacts-selector-permissions-popup.positioned {
  opacity: 1;
  visibility: visible;
}

/* Default: popup above icon */
.contacts-selector-permissions-popup.above {
  bottom: calc(100% + 12px);
}

/* Alternative: popup below icon */
.contacts-selector-permissions-popup.below {
  top: calc(100% + 12px);
}

/* Triangle pointing down when popup is above */
.contacts-selector-permissions-popup.above::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid white;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));
}

/* Triangle pointing up when popup is below */
.contacts-selector-permissions-popup.below::after {
  content: '';
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contacts-selector-permissions-popup-header {
  font-family: Roboto, Arial, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgb(51, 51, 51);
  margin-bottom: 8px;
}

.contacts-selector-permissions-popup-content {
  font-family: Roboto, Arial, sans-serif;
  font-size: 12px;
  color: rgb(102, 102, 102);
}

.contacts-selector-permissions-popup-content ul {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.contacts-selector-permissions-popup-content li {
  color: rgb(222, 72, 88);
  margin-bottom: 6px;
  line-height: 1.4;
}

.contacts-selector-permissions-popup-content li:last-child {
  margin-bottom: 0;
}

.contacts-selector-permissions-popup-content span {
  display: block;
  color: rgb(102, 102, 102);
}

.contacts-selector-limit-message {
  margin: 4px 0;
  padding: 6px 12px;
  font-size: 11px;
  line-height: 16px;
  color: var(--netsfere-red);
  background-color: color-mix(in srgb, var(--netsfere-red) 10%, transparent);
  border-radius: 3px;
  font-family: Roboto, Arial, sans-serif;
  text-align: center;
}

.contacts-selector-room-type {
  width: 100%;
  margin: 8px 0;
  padding: 8px 0;
  border-top: 1px solid rgb(224, 224, 224);
  border-bottom: 1px solid rgb(224, 224, 224);
}

.contacts-selector-list-container {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  min-height: 0; /* Ensures flex child can shrink below content size */
}

/* VZD Search Button */
.contacts-selector-vzd-button {
  color: rgb(222, 72, 88);
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  gap: 6px;
}

.contacts-selector-vzd-button img {
  width: 18px;
  height: 18px;
}

.contacts-selector-vzd-button:hover {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/ContactsSelector.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,0EAA0E;EAC1E,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,aAAa,EAAE,qDAAqD;AACtE;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".contacts-selector {\n  height: 100%;\n  width: 100%;\n  background-color: rgb(242, 242, 242);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.contacts-selector-controls {\n  padding: 8px;\n  width: calc(100% - 16px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.contacts-selector-search-container {\n  height: auto;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.contacts-selector-invite-button {\n  color: rgb(222, 72, 88);\n  font-family: Roboto, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: fit-content;\n}\n\n.contacts-selector-invite-button .material-icons {\n  font-size: 18px;\n  margin-right: 6px;\n}\n\n.contacts-selector-invite-button:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.contacts-selector-instructions {\n  margin: 8px 0;\n  font-size: 12px;\n  line-height: 18px;\n  color: rgb(153, 153, 153);\n  font-family: Roboto, Arial, sans-serif;\n  width: 100%;\n}\n\n.contacts-selector-permissions-line {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: rgb(102, 102, 102);\n  width: 100%;\n  margin: 8px 0 16px;\n}\n\n.contacts-selector-permissions-icon-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.contacts-selector-permissions-icon-wrapper ion-icon {\n  font-size: 24px;\n  color: rgb(71, 71, 71);\n  cursor: pointer;\n}\n\n.contacts-selector-permissions-icon-wrapper ion-icon:hover {\n  color: rgb(51, 51, 51);\n}\n\n.contacts-selector-permissions-popup {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 12px;\n  min-width: 280px;\n  max-width: 360px;\n  z-index: 2500;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.15s ease-in-out, visibility 0.15s ease-in-out;\n}\n\n.contacts-selector-permissions-popup.positioned {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Default: popup above icon */\n.contacts-selector-permissions-popup.above {\n  bottom: calc(100% + 12px);\n}\n\n/* Alternative: popup below icon */\n.contacts-selector-permissions-popup.below {\n  top: calc(100% + 12px);\n}\n\n/* Triangle pointing down when popup is above */\n.contacts-selector-permissions-popup.above::after {\n  content: '';\n  position: absolute;\n  bottom: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid white;\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.1));\n}\n\n/* Triangle pointing up when popup is below */\n.contacts-selector-permissions-popup.below::after {\n  content: '';\n  position: absolute;\n  top: -8px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-bottom: 8px solid white;\n  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.1));\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.contacts-selector-permissions-popup-header {\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  color: rgb(51, 51, 51);\n  margin-bottom: 8px;\n}\n\n.contacts-selector-permissions-popup-content {\n  font-family: Roboto, Arial, sans-serif;\n  font-size: 12px;\n  color: rgb(102, 102, 102);\n}\n\n.contacts-selector-permissions-popup-content ul {\n  margin: 0;\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.contacts-selector-permissions-popup-content li {\n  color: rgb(222, 72, 88);\n  margin-bottom: 6px;\n  line-height: 1.4;\n}\n\n.contacts-selector-permissions-popup-content li:last-child {\n  margin-bottom: 0;\n}\n\n.contacts-selector-permissions-popup-content span {\n  display: block;\n  color: rgb(102, 102, 102);\n}\n\n.contacts-selector-limit-message {\n  margin: 4px 0;\n  padding: 6px 12px;\n  font-size: 11px;\n  line-height: 16px;\n  color: var(--netsfere-red);\n  background-color: color-mix(in srgb, var(--netsfere-red) 10%, transparent);\n  border-radius: 3px;\n  font-family: Roboto, Arial, sans-serif;\n  text-align: center;\n}\n\n.contacts-selector-room-type {\n  width: 100%;\n  margin: 8px 0;\n  padding: 8px 0;\n  border-top: 1px solid rgb(224, 224, 224);\n  border-bottom: 1px solid rgb(224, 224, 224);\n}\n\n.contacts-selector-list-container {\n  flex: 1;\n  width: 100%;\n  overflow-y: auto;\n  min-height: 0; /* Ensures flex child can shrink below content size */\n}\n\n/* VZD Search Button */\n.contacts-selector-vzd-button {\n  color: rgb(222, 72, 88);\n  font-family: Roboto, sans-serif;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  width: fit-content;\n  gap: 6px;\n}\n\n.contacts-selector-vzd-button img {\n  width: 18px;\n  height: 18px;\n}\n\n.contacts-selector-vzd-button:hover {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
